import { uniq } from 'lodash'

export function resolveColumnOrder(columnOrder = [], keys = []) {
  return uniq([...columnOrder.filter(key => keys.includes(key)), ...keys])
}

export function reorderWithinSection(orderKeys, sectionItems, nextItems) {
  const sectionKeys = sectionItems.map(({ key }) => key)
  const nextKeys = nextItems.map(({ key }) => key)
  let cursor = 0
  return orderKeys.map(key => sectionKeys.includes(key) ? nextKeys[cursor++] : key)
}

export function moveOnPinToggle(orderKeys, key, nextPinnedKeys) {
  const others = orderKeys.filter(current => current !== key)
  return [
    ...others.filter(current => nextPinnedKeys.includes(current)),
    key,
    ...others.filter(current => !nextPinnedKeys.includes(current)),
  ]
}
